<!--begin::Title-->
<h3 class="font-bold fs-2hx text-gray-900 mb-4">Oops!</h3>
<!--end::Title-->

<!--begin::Text-->
<div class="fs-6 text-muted mb-7">We can't find that page.</div>
<!--end::Text-->

<!--begin::Illustration-->
<div class="mb-3 flex items-center justify-center w-full"> 
  <img
    src="./assets/media/auth/error404.jpg"
    class="max-w-full max-h-[300px] self-center"
    alt=""
  />
</div>
<!--end::Illustration-->

<!--begin::Link-->
<div class="mb-0">
  <button
    pButton
    [size]="'large'"
    class="!p-2 !px-4 !text-sm"
    (click)="routeToDashboard()"
  >
    Return Home
  </button>
</div>
<!--end::Link-->
